import { Image, TouchableOpacity, ViewStyle } from "react-native";
import { ImageSourcePropType } from "react-native/Libraries/Image/Image";
import { StyleProp } from "react-native/Libraries/StyleSheet/StyleSheet";
import { ImageStyle } from "react-native/Libraries/StyleSheet/StyleSheetTypes";

interface ImageViewProps {
    source?: ImageSourcePropType;
    onClick?: () => void;
    style?: ViewStyle;
    activeOpacity?: number;
    disabled?: boolean;
    imgStyle?: StyleProp<ImageStyle>;
}

export const ImageView = ({ source, onClick, style, activeOpacity, imgStyle, disabled }: ImageViewProps) => {
    return (<TouchableOpacity
        disabled={disabled}
        activeOpacity={activeOpacity} onPress={onClick} style={style}>
        {source && <Image source={source} style={imgStyle} onError={(err) => console.log(`----> onError:`, err)} />}
    </TouchableOpacity>);
};
